import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IAccountCode } from '../interfaces/account-code';
import { IAccountCodeFilter } from '../interfaces/account-code-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class AccountCodeService extends EditService<IAccountCode, IAccountCodeFilter> {
  url = '/api/accountcodes';
  entityTitle = 'Cost code';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  create(accountCode: IAccountCode): Promise<any> {
    let successMsg = accountCode.id == 0 ? 'Cost code added.' : 'Cost code updated.';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
    return this.handleRequest(
      this.http.post('api/accountcodes/save', accountCode, { headers: headers }),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }

  get(): Promise<any> {
    return this.handleRequest(
      this.http.get('api/accountcodes/get'),
      this.handlersFactory.getForReadAll(),
    );
  }

  getForSupplier(supplierId: number): Promise<any> {
    return this.handleRequest(
      this.http.get('api/accountcodes/getforsupplier/' + supplierId),
      this.handlersFactory.getForReadAll(),
    );
  }

  getCurrentUserOrgId(): Promise<any> {
    return this.handleRequest(
      this.http.get('/api/accountcodes/getcurrentuserorgid'),
      this.handlersFactory.getDefault(),
    );
  }

  getForCurrentUserOrg(): Promise<IAccountCode[]> {
    return this.handleRequest(
      this.http.get<IAccountCode[]>('/api/accountcodes/getbycurrentuserorg'),
      this.handlersFactory.getDefault(),
    );
  }

  getForCustomerUser(): Promise<IAccountCode> {
    return this.handleRequest(
      this.http.get<IAccountCode>('/api/accountcodes/getforcustomeruser'),
      this.handlersFactory.getDefault(),
    );
  }
}
